// extracted by mini-css-extract-plugin
export default {"ckDescription":"SinglePortfolio_ckDescription__Yz6Aj","options":"SinglePortfolio_options__Hll3R"};